import { useTranslation } from 'react-i18next';
import PageHeader from '@casops/components/layout/page-header/PageHeader';
import StandardPage from '@casops/templates/standard-page/StandardPage';
import MapSettings from './components/map-settings/MapSettings';
import styles from './SettingsPage.module.scss';
import { ReactElement } from 'react';
import LocalizationSettings from './components/localization-settings/LocalizationSettings';
import SiteDetails from './components/site-details-settings/SiteDetailsSettings';

export function SettingsPage(): ReactElement {
  const { t } = useTranslation();

  return (
    <StandardPage header={<PageHeader title={t(`Navigation.Settings`)} />}>
      <div className={styles.cards}>
        <SiteDetails />
        <LocalizationSettings />
        <MapSettings />
      </div>
    </StandardPage>
  );
}

export default SettingsPage;
